
import React from "react";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import SEO from "@/components/SEO";
import Breadcrumb from "@/components/Breadcrumb";
import StructuredData from "@/components/StructuredData";
import DepartmentSEOPage from "@/components/seo/DepartmentSEOPage";
import RequestFormSection from "@/components/location-bennes/RequestFormSection";
import { departmentSEOData } from "@/data/departmentSEOData";
import { departements } from "@/components/location-bennes/LocationData";

const LocationBennesLozereSEO = () => {
  const departmentData = departmentSEOData["48"];
  const nearbyDepartments = departements.filter(d => 
    ["12", "15", "30", "34", "81"].includes(d.code)
  );

  const localServiceSchema = {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    "@id": "https://www.groupefabre-environnement.fr/nos-services/location-bennes/48#business",
    "name": "Groupe Fabre Environnement - Location de bennes Lozère",
    "description": "Service professionnel de location de bennes en Lozère. Intervention à Mende, Marvejols, Florac. Haute montagne, solutions adaptées.",
    "url": "https://www.groupefabre-environnement.fr/nos-services/location-bennes/48",
    "telephone": "+33565787900",
    "email": "contactgfe@groupefabre.com",
    "address": {
      "@type": "PostalAddress",
      "addressLocality": "Mende",
      "addressRegion": "Lozère",
      "postalCode": "48000",
      "addressCountry": "FR"
    },
    "areaServed": [
      {
        "@type": "AdministrativeArea",
        "name": "Lozère",
        "containsPlace": [
          {"@type": "City", "name": "Mende"},
          {"@type": "City", "name": "Marvejols"},
          {"@type": "City", "name": "Florac"},
          {"@type": "City", "name": "Saint-Chély-d'Apcher"},
          {"@type": "City", "name": "Langogne"}
        ]
      }
    ],
    "serviceType": "Location de bennes et gestion des déchets"
  };

  return (
    <div className="min-h-screen flex flex-col">
      <SEO 
        title="Location de Bennes Lozère (48) - Mende, Marvejols, Florac | Groupe Fabre"
        description="Location de bennes en Lozère. Service professionnel à Mende, Marvejols, Florac. Haute montagne, tarifs dès 120€, livraison 24-48h."
        canonical="/nos-services/location-bennes/48"
        keywords="location benne Lozère, benne Mende, location benne Florac, déchets Lozère, benne montagne, location conteneur Lozère"
        localBusiness={{
          city: "Mende",
          region: "Lozère",
          postalCode: "48000",
          serviceType: "Location de bennes"
        }}
      />
      
      <StructuredData data={localServiceSchema} />
      
      <Navbar />
      
      <main className="flex-1 pt-20">
        <nav aria-label="Fil d'Ariane" className="bg-gray-50 py-3 border-b border-gray-200">
          <div className="container mx-auto px-4">
            <Breadcrumb
              items={[
                { label: "Services", href: "/nos-services" },
                { label: "Location de bennes", href: "/nos-services/location-bennes" },
                { label: "Lozère (48)", href: "/nos-services/location-bennes/48", current: true }
              ]}
            />
          </div>
        </nav>

        <article className="py-12 bg-gray-50">
          <div className="container mx-auto px-4">
            <DepartmentSEOPage
              departmentCode={departmentData.code}
              departmentName={departmentData.name}
              region={departmentData.region}
              mainCities={departmentData.mainCities}
              description={departmentData.description}
              heroTitle={departmentData.heroTitle}
              heroSubtitle={departmentData.heroSubtitle}
              specificServices={departmentData.specificServices}
              localTestimonial={departmentData.localTestimonial}
              nearbyDepartments={nearbyDepartments}
            />
            
            <section id="request-form" className="mt-12">
              <RequestFormSection />
            </section>
          </div>
        </article>
      </main>

      <Footer />
    </div>
  );
};

export default LocationBennesLozereSEO;
